var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rangedubleslider",attrs:{"id":"time-range"}},[_c('p',[_vm._v(_vm._s(_vm.$t("sabre.search-result.between-hours")))]),_c('div',{staticClass:"sliders_step1"},[_c('div',{ref:`range-slider-${_vm._uid}`})])])
}
var staticRenderFns = []

export { render, staticRenderFns }